import { fetchResearchedProduct } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ResearchedProductKeys = {
    all: ['researchedproduct'] as const,
    lists: () => [...ResearchedProductKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ResearchedProductKeys.lists(), page, perPage, filters] as const,
    details: () => [...ResearchedProductKeys.all, 'detail'] as const,
    detail: (params: number) => [...ResearchedProductKeys.details(), params] as const,
}

export const useResearchedProductQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchResearchedProduct(SK_PESQUISA),
        queryKey: ResearchedProductKeys.detail(SK_PESQUISA),
    })
}
